import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

const AnalyzeOnLichess = ({ studyId, chapterName, apiToken, pgn }) => {
    const [responseMessage, setResponseMessage] = useState("");
    const [createdChapterId, setCreatedChapterId] = useState(null);

    const deleteChapter = (chapterId) => {
        const url = `https://lichess.org/api/study/${studyId}/chapter/${chapterId}`;
        try {
            // Prepare headers for the delete request
            const headers = {
                Authorization: `Bearer ${apiToken}`,
            };

            // Send request using navigator.sendBeacon
            const success = navigator.sendBeacon(url, JSON.stringify({ headers }));
            if (!success) {
                console.error("Failed to send delete request using Beacon.");
            } else {
                console.log(`Chapter ${chapterId} deleted successfully.`);
            }
        } catch (error) {
            console.error(`Error deleting chapter: ${error.message}`);
        }
    };

    const createChapter = async () => {
        if (!studyId || !apiToken || !pgn) {
            setResponseMessage("Error: Missing required parameters.");
            return;
        }

        const url = `https://lichess.org/api/study/${studyId}/import-pgn`;

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    Authorization: `Bearer ${apiToken}`,
                },
                body: new URLSearchParams({
                    pgn: pgn,
                    name: chapterName,
                }),
            });

            if (response.ok) {
                const responseData = await response.json();
                const chapterId = responseData.chapters[0].id;
                setCreatedChapterId(chapterId);

                const chapterUrl = `https://lichess.org/study/${studyId}/${chapterId}?analysis=true`;
                window.open(chapterUrl, "_blank");

                setResponseMessage("Chapter created successfully!");
            } else {
                const errorData = await response.json();
                setResponseMessage(`Error: ${errorData.error || "Failed to create chapter."}`);
            }
        } catch (error) {
            setResponseMessage(`Error: ${error.message}`);
        }
    };

    useEffect(() => {
        const handleTabClose = (event) => {
            if (createdChapterId) {
                console.log(`Attempting to delete chapter: ${createdChapterId}`);
                deleteChapter(createdChapterId);
            }
        };

        // Use the unload event for handling tab close
        window.addEventListener("unload", handleTabClose);

        return () => {
            window.removeEventListener("unload", handleTabClose);
        };
    }, [createdChapterId]);

    return (
        <Box sx={{ textAlign: "center" }}>
            <Button
                variant="contained"
                color="primary"
                onClick={createChapter}
                sx={{ margin: "10px" }}
            >
                Analyze on Lichess
            </Button>
            {responseMessage && <p style={{ color: "red" }}>{responseMessage}</p>}
        </Box>
    );
};

export default AnalyzeOnLichess;
